var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-btn',_vm._g(_vm._b({on:{"click":_vm.onClick}},'q-btn',Object.assign({}, {loading: _vm.loading}, _vm.$attrs),false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }